import { Phone, Mail, MapPin, Globe } from "lucide-react";
import { scrollToId, prefillQuote, GMB_MESSAGE, CONTACT } from "@/lib/scroll";

const LINKS = [
    { label: "Home", id: "hero" },
    { label: "Services", id: "features" },
    { label: "About Us", id: "about" },
    { label: "Work", id: "portfolio" },
    { label: "Blog", id: "blog" },
    { label: "Contact", id: "contact" },
];

export default function Footer() {
    return (
        <footer className="border-t border-[#00C6FF]/12 bg-[#040910] py-14" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col gap-10 lg:flex-row lg:items-start lg:justify-between">
                    <div className="max-w-sm">
                        <div className="flex items-center">
                            <img
                                src="/logo.webp"
                                alt="Prime 360 View — Explore. Experience. Grow."
                                className="logo-flip h-11 w-auto"
                            />
                        </div>
                        <p className="mt-4 text-sm leading-relaxed text-slate-400">
                            Don't just show your space. Let them experience it.
                            Immersive 360° virtual tours crafted in Pune, India.
                        </p>
                    </div>
                    <div className="flex flex-wrap gap-x-8 gap-y-3">
                        {LINKS.map((l) => (
                            <button
                                key={l.id}
                                data-testid={`footer-link-${l.id}`}
                                onClick={() => scrollToId(l.id)}
                                className="text-xs uppercase tracking-[0.2em] text-slate-400 transition-colors hover:text-[#00C6FF]"
                            >
                                {l.label}
                            </button>
                        ))}
                    </div>
                    <div className="space-y-2.5 text-sm text-slate-400">
                        <p className="flex items-center gap-2.5">
                            <Phone size={14} className="text-[#00C6FF]" /> {CONTACT.phone}
                        </p>
                        <p className="flex items-center gap-2.5">
                            <Mail size={14} className="text-[#00C6FF]" /> {CONTACT.email}
                        </p>
                        <p className="flex items-center gap-2.5">
                            <MapPin size={14} className="text-[#00C6FF]" /> {CONTACT.location}
                        </p>
                        <button
                            data-testid="footer-gmb-btn"
                            onClick={() => prefillQuote(GMB_MESSAGE)}
                            className="mt-2 flex items-center gap-2.5 rounded-full border border-[#00C6FF]/40 px-5 py-2.5 text-xs font-bold uppercase tracking-[0.15em] text-[#00C6FF] transition-colors hover:bg-[#00C6FF]/10"
                        >
                            <Globe size={14} />
                            Not on Google yet? Create my listing
                        </button>
                    </div>
                </div>
                <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-[#00C6FF]/10 pt-6 sm:flex-row">
                    <p className="text-xs text-slate-500">
                        © {new Date().getFullYear()} Prime 360 View · prime360view.in
                    </p>
                    <p className="font-mono-accent text-[10px] tracking-[0.3em] text-slate-600">
                        EVERY ANGLE. EVERY SPACE. EVERY TIME.
                    </p>
                </div>
            </div>
        </footer>
    );
}
